export const ModalTitle = {
  REPLY: 'Give supporting reasons for your request',
  APPROVE: 'Confirm approval',
  DECLINE: 'Are you sure you want to decline?',
  REQUEST_REASONS: 'Request supporting reasons',
  COMMENT: 'Add a comment',
  CANCEL_REQUEST: 'Are you sure you want to cancel the request?',
  ASSIGN_TASK: 'Are you sure?',
  UNASSIGN_TASK: 'Are you sure you want to unassign the request?',
  CHANGE_ASSIGNEE: 'Reassign to',
  APPROVE_PRODUCT_DELETE: 'Approve product data deletion',
};
